import Observer from 'fontfaceobserver';
import { injectGlobal } from 'react-emotion';
function injectPrimaryStyles(family, fontClassName) {
    injectGlobal `
  .${fontClassName} body {
    font-family: '${family}', sans-serif;
    line-height: 1;
    letter-spacing: 0;
    word-spacing: 0;
    font-weight: normal;
  }
  `;
}
function createFontClass(family) {
    return `${family.replace(/ +/g, '-').toLowerCase()}-ready`;
}
export function injectFont(primaryFont, secondaryFonts) {
    // Add `xxxx-ready` styles to set the primary (body) font
    if (primaryFont) {
        const primaryFontClassName = createFontClass(primaryFont);
        injectPrimaryStyles(primaryFont, primaryFontClassName);
        // observe body font
        const primaryFontObserver = new Observer(primaryFont);
        primaryFontObserver.load().then(() => {
            const fontClass = createFontClass(primaryFont);
            document && document.documentElement.classList.add(fontClass);
        }, () => {
            console.log(`Font ${primaryFont} not available`);
        });
    }
    // observe any secondary fonts
    if (secondaryFonts && secondaryFonts.length > 0) {
        const fonts = secondaryFonts.map(font => new Observer(font));
        Promise.all(fonts.map(f => f.load())).then(function (e) {
            e.map((fam) => {
                const fontClass = createFontClass(fam.family);
                document && document.documentElement.classList.add(fontClass);
            });
        }, () => {
            console.log('Secondary fonts not available');
        });
    }
}
//# sourceMappingURL=injectFont.js.map